import { render, staticRenderFns } from "./phoneField.vue?vue&type=template&id=21845db4&scoped=true"
import script from "./phoneField.vue?vue&type=script&lang=js"
export * from "./phoneField.vue?vue&type=script&lang=js"
import style0 from "./phoneField.vue?vue&type=style&index=0&id=21845db4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21845db4",
  null
  
)

export default component.exports